const convertToPyeong = (origin: number) => {
    return Math.round(origin / 3.305785);
};
export default convertToPyeong;
